<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: 'App',
  beforeCreate() {
    document.title = decodeURI(Cookies.get('APP_TITLE'))
  },
  created() {
    // 根据设备调用不同样式文件
    if (this.isMobile()) {
      document.querySelector('#style').setAttribute('href', 'mob.css')
    } else {
      document.querySelector('#style').setAttribute('href', 'pc.css')
    }
  },
  methods: {
    // 判断设备
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }
  }
}
</script>
<style>
.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
</style>
